import ClosetObject from '@sas-dvr/ltjs-commons/ClosetObject';
import DataSetDataProvider from '../models/data/DataSetDataProvider';
import Serializer from '@sas-dvr/ltjs-commons/serializers/Serializer';
import SerializationFormat from '@sas-dvr/ltjs-commons/serializers/SerializationFormat';
export function hasAccelerator() {
    return !!window.SASGraphicsAccelerator_attendance;
}
/**
 * Prints out <IQData> XML for a dataProvider for use by the Accessibility Accelerator
 * @param {DataProvider} dataProvider - the dataProvider to use
 * @returns {String} The XML generated
 */
export function getDataModelString(dataProvider) {
    if (!dataProvider) {
        return null;
    }
    // NOTE(mikcol): legacy would set this to undefined
    var data = null;
    var dataSet = dataProvider.getDataSet();
    if (dataSet) {
        var numRows = dataSet.getNumberOfRows();
        var numColumns = dataSet.getNumberOfColumns();
        if (numColumns > 0 && numRows > 0) {
            var columns = dataSet.getColumns();
            if (!columns) {
                return null;
            }
            data = '<DataModel><IQData type="2DEmbedded" name="' + dataSet.getName() + '"><EmbeddedData><Variables>';
            for (var _i = 0, columns_1 = columns; _i < columns_1.length; _i++) {
                var column = columns_1[_i];
                if (!column) {
                    continue;
                }
                var type = void 0;
                if (column.isNumber()) {
                    type = 'Number';
                }
                else if (column.isString()) {
                    type = 'String';
                }
                else if (column.isDateTime()) {
                    type = 'DateTime';
                }
                var format = column.getFormatName();
                var formatStr = '';
                if (format) {
                    formatStr = ' SASFormat="' + format + '"';
                }
                data +=
                    '<Variable name="' +
                        column.getName() +
                        '" label="' +
                        column.getLabel() +
                        '" type="' +
                        String(type) +
                        '" valuesCount="' +
                        String(numRows) +
                        '"' +
                        formatStr +
                        '/>';
            }
            data += '</Variables><ValuesList valuesCount="' + String(numRows) + '">';
            for (var j = 0; j < numRows; j++) {
                for (var _a = 0, columns_2 = columns; _a < columns_2.length; _a++) {
                    var column = columns_2[_a];
                    if (!column) {
                        continue;
                    }
                    var dataValue = column.getDataValueAtIndex(j, false);
                    if (!dataValue) {
                        continue;
                    }
                    var val = '';
                    var valFormatted = '';
                    if (dataValue.isMissing()) {
                        if (dataValue.isString()) {
                            valFormatted = ' M=" "';
                        }
                        else {
                            valFormatted = ' M="."';
                        }
                    }
                    else if (dataValue.isString()) {
                        val = dataValue.getFormattedValue();
                    }
                    else {
                        val = String(dataValue.getNumericValue());
                        valFormatted = ' F="' + dataValue.getFormattedValue() + '"';
                    }
                    data += '<V' + valFormatted + '>' + val + '</V>';
                }
            }
            // TODO print LetStats, including info in column.getAggregation()
            data += '</ValuesList></EmbeddedData></IQData></DataModel>';
        }
    }
    return data;
}
/**
 * Serializes a provided graph model and returns a SASReport xml as a string.
 * @param {GTLModel} graphModel - the Graph GTL Model object
 * @returns {string} SASReport xml as a string
 */
export function getAccelleratorContent(graphModel) {
    if (!graphModel) {
        return null;
    }
    var dataProviders = graphModel.getAllDataProviders();
    if (!dataProviders) {
        return null;
    }
    var data = '';
    var processedDataSets = [];
    var _loop_1 = function (i) {
        var dataProvider = dataProviders[i];
        if (dataProvider instanceof DataSetDataProvider) {
            var dataSet_1 = dataProvider.getDataSet();
            // make sure the same data set isn't going in multiple times
            if (dataSet_1 && !processedDataSets.find(function (pr) { return ClosetObject.equals(pr, dataSet_1); })) {
                var dataModelString = getDataModelString(dataProvider);
                data += dataModelString;
                processedDataSets.push(dataSet_1);
            }
        }
    };
    for (var i = 0; i < dataProviders.length; i++) {
        _loop_1(i);
    }
    if (!data) {
        return null;
    }
    var serializer = new Serializer();
    var gtml = serializer.serialize(graphModel, 0, SerializationFormat.XML);
    if (!gtml) {
        return null;
    }
    return '<SASReport version="1.2"><Data version="9.4m4">' + data + '</Data><View>' + gtml + '</View></SASReport>';
}
/**
 * Notifies the Accessibility Accelerator that there is a graph to process.
 * @param {GTLModel} graphModel - the gtl model of the graph
 * @param {String} [title] - title of the graph (must already be html escaped/encoded, usually this is provided by the graph's accessibilityLabel)
 * @param {String} [description] - optional description of the graph
 */
export function notifyAccelerator(graphModel, title, description) {
    var report = getAccelleratorContent(graphModel);
    if (report) {
        document.dispatchEvent(new CustomEvent('SASGraphicsAccelerator-notify', {
            detail: {
                title: title,
                description: description,
                report: report,
            },
        }));
    }
}
